import { Component, Input } from '@angular/core';

/**
 * If you use modal (like this component)
 * don't forget to use the inceptionService.init() to avoid this kind of error
 * TypeError: Cannot read properties of undefined (reading 'css')
 * */

@Component({
  selector: 'mprd-generic-modal',
  templateUrl: './generic-modal.component.html',
})
export class GenericModalComponent {
  @Input() title: string;
  @Input() content: any;
  @Input() idModal: string;
  @Input() confirmCTAName: string;
  @Input() cancelCTAName: string;
  @Input() confirmCTA?: any; // callback function
  @Input() dataCy?: string;
  constructor() {}

  confirmClick() {
    if (this.confirmCTA) return this.confirmCTA();
    return;
  }
}
